import React from 'react'
import PropTypes from 'prop-types'
import { createStyles, makeStyles } from '@material-ui/core'
import clsx from 'clsx'

export const pillColors = {
  gray: 'text-gray-800 bg-gray-200',
  red: 'bg-red-100 text-red-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  green: 'bg-green-100 text-green-800',
  blue: 'bg-blue-100 text-blue-800',
  pink: 'bg-pink-100 text-pink-800',
  purple: 'bg-purple-100 text-purple-800',
  orange: 'bg-orange-100 text-orange-800',

  indigo: 'bg-indigo-100 text-indigo-800',
  greenLight2: 'bg-custom-green-light2 text-green-800'
}

export const pillVariantObj = {
  paid: 'green',
  draft: 'yellow',
  uncollectible: 'pink',
  open: 'green',
  send: 'blue',
  pending: 'yellow',
  rejected: 'red',
  overdue: 'red',
  resolved: 'green',
  accepted: 'green',
  approved: 'green',
  closed: 'gray',
  canceled: 'yellow',
  finalize: 'blue',
  completed: 'green',
  inProgress: 'red'
}

export const taskStatusVariants = {
  completed: 'green',
  review: 'orange',
  blocked: 'indigo',
  pending: 'yellow',
  open: 'gray',
  inProgress: 'red'
}

const Pill = props => {
  const { variant, className = '', ...rest } = props
  const classes = useStyles()
  return (
    <span
      {...rest}
      className={clsx(
        'inline-flex items-center rounded-full px-3 py-0.5 font-medium whitespace-nowrap',
        classes.generalStyle,
        pillColors[variant],
        className
      )}
    >
      {props.children}
    </span>
  )
}
export default Pill

const useStyles = makeStyles(theme =>
  createStyles({
    generalStyle: {
      fontSize: '9px',
      userSelect: 'none',
      height: 23,
      lineHeight: '23px',
      boxSizing: 'content-box',
      '@media (min-width: 1684px)': {
        fontSize: '10px',
        height: 25,
        lineHeight: '25px'
      }
    },
    purple: {
      backgroundColor: '#fbcffc'
    }
  })
)
Pill.propTypes = {
  variant: PropTypes.oneOf([
    'gray',
    'pink',
    'purple',
    'red',
    'blue',
    'yellow',
    'green',
    'indigo'
  ])
}
